import classNames from "classnames";
import { ReactNode } from "react";
import styles from "./PlainList.module.css";

//#region [Props]
type PlainListProps = {
    children: ReactNode;
    className?: string;
};
//#endregion

//#region [Component]
export default function PlainList({ children, className }: PlainListProps) {
    return <ul className={classNames(styles.PlainList, className)}>{children}</ul>;
}
//#endregion

//#region [Styles]

//#endregion